import React from "react";
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} Rajiv Life Sciences. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
